"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("../Dialog/classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var DialogIcon = function DialogIcon(_ref) {
  var Icon = _ref.icon,
    color = _ref.color,
    fontSize = _ref.fontSize;
  return /*#__PURE__*/_react["default"].createElement(Icon, {
    style: {
      fontSize: fontSize
    },
    color: color,
    className: _classnames["default"].DIALOG_ICON
  });
};
DialogIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: _propTypes["default"].elementType.isRequired,
  fontSize: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary'])
} : {};
DialogIcon.defaultProps = {
  color: 'inherit',
  fontSize: '32px'
};
var _default = exports["default"] = DialogIcon;